import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const MyPage = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        // Flask 백엔드의 mypage_bp.route('/api/mypage') 호출
        axios.get('/api/mypage')
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                if (err.response?.status === 401) {
                    navigate('/login');
                }
                setLoading(false);
            });
    }, [navigate]);

    const handleLogout = async () => {
        if (!window.confirm("로그아웃 하시겠습니까?")) return;
        try {
            await axios.post('/api/auth/logout', {}, { withCredentials: true });
            logout();
            navigate('/');
        } catch (err) {
            console.error(err);
        }
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>로딩 중...</div>;
    if (!data) return null;

    // Flask 원본 변수명 그대로 구조 분해 할당
    const { nickname, paid_count, delivery_counts } = data;

    return (
        <>
            <style>{`
                .status-circle {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    background-color: #f5f5f5;
                    font-weight: bold;
                    line-height: 48px;
                    text-align: center;
                    margin: auto;
                    font-size: 18px;
                    color: #333;
                }
                .status-label {
                    margin-top: 6px;
                    font-size: 14px;
                    text-align: center;
                    color: #555;
                }
                .status-icon-row {
                    display: flex;
                    flex-wrap: nowrap;
                    width: 100%;
                    justify-content: space-between;
                    align-items: center;
                    overflow-x: auto;
                    background-color: #fff;
                    padding: 20px 0;
                }
                .status-col {
                    flex: 1;
                    min-width: 0;
                    text-align: center;
                }
                .status-separator {
                    font-size: 24px;
                    color: #999;
                    margin: 0 0.5rem;
                    user-select: none;
                }
                .mypage-list {
                    max-width: 600px;
                    margin: 0 auto;
                    padding-left: 0;
                    list-style: none;
                }
                .mypage-list li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 12px 16px;
                    border-bottom: 1px solid #ddd;
                    background-color: #fff;
                }
                .mypage-list li:last-child {
                    border-bottom: none;
                }
                .mypage-list a,
                .mypage-list button {
                    color: #222;
                    text-decoration: none !important;
                    flex-grow: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 16px;
                    background: none;
                    border: none;
                    padding: 0;
                    text-align: left;
                    cursor: pointer;
                }
                .mypage-list .arrow {
                    flex: 0 0 16px;
                    color: #888;
                    font-weight: bold;
                    margin-left: 8px;
                }
                .container-custom {
                    max-width: 600px;
                    margin: 20px auto 50px;
                    padding: 0 15px;
                }
                @media (max-width: 480px) {
                    .mypage-list li { padding: 10px 12px; }
                    .mypage-list a,
                    .mypage-list button { white-space: normal; font-size: 15px; }
                }
            `}</style>

            <div className="container-custom">
                {/* 주문/배송현황 */}
                <div className="mb-5" style={{ marginBottom: '3rem' }}>
                    <h6 style={{ fontWeight: 'bold', color: '#212529', marginBottom: '1rem' }}>
                        주문/배송현황
                    </h6>
                    <div className="status-icon-row">
                        <div className="status-col">
                            <Link to="/order/status?status=결제완료" style={{ textDecoration: 'none' }}>
                                <div className="status-circle">{paid_count}</div>
                                <div className="status-label">결제완료</div>
                            </Link>
                        </div>

                        <div className="status-separator">›</div>

                        <div className="status-col">
                            <Link to="/order/status?status=배송준비중" style={{ textDecoration: 'none' }}>
                                <div className="status-circle">{delivery_counts['배송준비중']}</div>
                                <div className="status-label">배송준비중</div>
                            </Link>
                        </div>

                        <div className="status-separator">›</div>

                        <div className="status-col">
                            <Link to="/order/status?status=배송중" style={{ textDecoration: 'none' }}>
                                <div className="status-circle">{delivery_counts['배송중']}</div>
                                <div className="status-label">배송중</div>
                            </Link>
                        </div>

                        <div className="status-separator">›</div>

                        <div className="status-col">
                            <Link to="/order/status?status=배송완료" style={{ textDecoration: 'none' }}>
                                <div className="status-circle">{delivery_counts['배송완료']}</div>
                                <div className="status-label">배송완료</div>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* 쇼핑정보 */}
                <div className="mb-5" style={{ marginBottom: '3rem' }}>
                    <h6 style={{ fontWeight: 'bold', color: '#212529', marginBottom: '1rem' }}>스마트팜</h6>
                    <ul className="mypage-list">
                        <li>
                            <Link to="/smartfarm">스마트 팜</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/farm-diary/list">영농 일지</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/today-farm">오늘 농장</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                    </ul>
                </div>

                <div className="mb-5" style={{ marginBottom: '3rem' }}>
                    <h6 style={{ fontWeight: 'bold', color: '#212529', marginBottom: '1rem' }}>쇼핑정보</h6>
                    <ul className="mypage-list">
                        <li>
                            <Link to="/order/list">주문 내역</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/claim">교환 반품</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/coupon">내 쿠폰</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/wishlist">위시리스트</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                    </ul>
                </div>

                {/* 회원정보 */}
                <div className="mb-5" style={{ marginBottom: '3rem' }}>
                    <h6 style={{ fontWeight: 'bold', color: '#212529', marginBottom: '1rem' }}>회원정보</h6>
                    <ul className="mypage-list">
                        <li>
                            <Link to="/reviews">리뷰 내역</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/qna">상품 문의</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <Link to="/address/list">배송지 관리</Link>
                            <span className="arrow">&gt;</span>
                        </li>
                        <li>
                            <button type="button" onClick={handleLogout}>로그아웃</button>
                            <span className="arrow">&gt;</span>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default MyPage;